/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Category } from '../models/Category';
import type { PaginatedCategoryList } from '../models/PaginatedCategoryList';
import type { PatchedCategory } from '../models/PatchedCategory';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CategoriesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedCategoryList
     * @throws ApiError
     */
    public categoriesList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedCategoryList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/categories/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns Category
     * @throws ApiError
     */
    public categoriesCreate({
        requestBody,
    }: {
        requestBody: Category,
    }): CancelablePromise<Category> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/categories/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Category
     * @throws ApiError
     */
    public categoriesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this category.
         */
        id: number,
    }): CancelablePromise<Category> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/categories/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Category
     * @throws ApiError
     */
    public categoriesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this category.
         */
        id: number,
        requestBody: Category,
    }): CancelablePromise<Category> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/categories/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Category
     * @throws ApiError
     */
    public categoriesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this category.
         */
        id: number,
        requestBody?: PatchedCategory,
    }): CancelablePromise<Category> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/categories/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public categoriesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this category.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/categories/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
